(function () {
  function colorTokenFromAlt(alt) {
    if (!alt) return null;
    var m = alt.match(/^(.*)\s+product image\s+\d+\s*$/i);
    if (!m) return null;
    var parts = m[1].trim().split(/\s+/);
    return parts.length ? parts[parts.length - 1].toUpperCase() : null;
  }

  function reorder(list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('li[data-media-id]'));
    if (items.length < 2) return;
    var active = items.filter(function (item) { return item.classList.contains('is-active'); })[0] || items[0];
    var activeImg = active.querySelector('img');
    var token = activeImg && colorTokenFromAlt(activeImg.alt);
    if (!token) return;
    var matches = [];
    var rest = [];
    items.forEach(function (item) {
      var img = item.querySelector('img');
      var itemToken = img && colorTokenFromAlt(img.alt);
      (itemToken === token ? matches : rest).push(item);
    });
    // Require every item to be classifiable and at least one non-matching group,
    // otherwise leave everything alone (fail safe: never hide images we can't confidently sort).
    if (matches.length < 2 || rest.length === 0) return;
    var classifiedAll = items.every(function (item) {
      var img = item.querySelector('img');
      return img && colorTokenFromAlt(img.alt);
    });
    if (!classifiedAll) return;
    var reordered = matches.concat(rest);
    var frag = document.createDocumentFragment();
    reordered.forEach(function (item) { frag.appendChild(item); });
    list.appendChild(frag);
    // Use an inline !important display override — the theme's own CSS sets
    // `.product__media-item { display: block !important; }` (and a flex variant on
    // mobile), which otherwise defeats the plain `hidden` attribute (a non-!important
    // UA rule) and leaves "hidden" items visibly rendered when scrolling.
    matches.forEach(function (item) {
      item.hidden = false;
      item.style.removeProperty('display');
    });
    rest.forEach(function (item) {
      item.hidden = true;
      item.style.setProperty('display', 'none', 'important');
    });
  }

  function setup(root) {
    if (!root || root.dataset.mxColorSyncReady === 'true') return;
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) return;
    var gallery = root.querySelector('media-gallery');
    var list = gallery && gallery.querySelector('[id^="Slider-Gallery"]');
    if (!list) return;
    root.dataset.mxColorSyncReady = 'true';
    var sectionId = root.dataset.originalSection || root.dataset.section;
    subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
      if (sectionId && evt && evt.data && evt.data.sectionId && evt.data.sectionId !== sectionId) return;
      reorder(list);
    });
    reorder(list);
  }

  function init() {
    document.querySelectorAll('product-info.mx-product-page').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
